import { FileText, CheckCircle, Clock, ArrowRight } from "lucide-react";
import type { StatCardConfig } from "../../common";

/** My-survey stat cards — same keys as current frontend, token styling. */
export const MY_SURVEY_STATS_CARDS: StatCardConfig[] = [
  {
    key: "totalAssigned",
    label: "Total Assigned",
    icon: FileText,
    iconBg: "var(--color-primary-100)",
    iconColor: "var(--color-primary-700)",
  },
  {
    key: "completed",
    label: "Completed",
    icon: CheckCircle,
    iconBg: "var(--color-success-light)",
    iconColor: "var(--color-success-dark)",
  },
  {
    key: "pending",
    label: "Pending",
    icon: Clock,
    iconBg: "var(--color-warning-light)",
    iconColor: "var(--color-warning-dark)",
  },
  {
    key: "inProgress",
    label: "In Progress",
    icon: ArrowRight,
    iconBg: "var(--color-secondary-100)",
    iconColor: "var(--color-secondary-600)",
  },
];
